export const MENTION_TYPES = {
  USER: 'user',
  SKILL: 'skill',
  ACTION: 'action'
};

export const MENTION_TYPE_ORDER = [
  MENTION_TYPES.USER,
  MENTION_TYPES.SKILL,
  MENTION_TYPES.ACTION
];

export const MENTION_TYPE_LABELS = {
  user: 'People',
  skill: 'Skills',
  action: 'Actions'
};

export const DEFAULT_MENTION_TYPES = [MENTION_TYPES.USER];

export const ASSISTANT_MENTION_TYPES = [
  MENTION_TYPES.USER,
  MENTION_TYPES.SKILL,
  MENTION_TYPES.ACTION
];

export const MENTION_SEARCH_LIMIT = 5;

const placeholderNouns = {
  user: 'a person',
  skill: 'a skill',
  action: 'an action'
};

export function getMentionTypes(editor) {

  if (Array.isArray(editor.mentionTypes) === false) {
    return DEFAULT_MENTION_TYPES;
  }

  if (editor.mentionTypes.length === 0) {
    return DEFAULT_MENTION_TYPES;
  }

  return editor.mentionTypes;

}

export function getMentionInputPlaceholder(mentionTypes) {

  const nouns = [];

  for (const type of MENTION_TYPE_ORDER) {

    if (mentionTypes.indexOf(type) !== -1) {
      nouns.push(placeholderNouns[type]);
    }

  }

  if (nouns.length === 1) {
    return `Mention ${nouns[0]}`;
  }

  const lastNoun = nouns.pop();

  return `Mention ${nouns.join(', ')} or ${lastNoun}`;

}
